module.exports = __webpack_public_path__ + "static/media/phone.1299d8d3.svg";